// Modules
import React, { ReactNode } from 'react'
import { ThemeProvider } from '@dasa-health/alma-react'

// Components
import { navTheme } from 'theme'
import { useCurrentLaboratory } from 'redesign/hooks/useCurrentLaboratory'
import { SnackbarProvider } from 'redesign/context/snackbar'
import { CustomSnackbar } from 'redesign/components/molecules/CustomSnackbar'
import { LateralBannerNewLogin } from 'components/LateralBannerNewLogin'
import { Container, ContainerContent, ContainerPage, CustomImage } from './styles'

interface TemplateContainerProps {
    children: ReactNode
    renderTemplateLogoNav?: boolean
}

export const TemplateNewLogin = ({ children, renderTemplateLogoNav = true }: TemplateContainerProps) => {
    const { currentLaboratory, currentLaboratoryStorage } = useCurrentLaboratory()
    const laboratory = currentLaboratory ? currentLaboratory : currentLaboratoryStorage

    return (
        <SnackbarProvider>
            <Container>
                <LateralBannerNewLogin bgColor={laboratory?.titleBgColor} name={laboratory?.name} />
                <ContainerContent>
                    <ContainerPage>
                        {renderTemplateLogoNav && <CustomImage alt={laboratory?.name} src={laboratory?.image} />}
                        {children}
                    </ContainerPage>
                </ContainerContent>
                <ThemeProvider theme={navTheme}>
                    <CustomSnackbar />
                </ThemeProvider>
            </Container>
        </SnackbarProvider>
    )
}
